// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mh-c";
export var backButton = "_mh-4";
export var backIcon = "_mh-5";
export var chevronShortcut = "_mh-6";
export var container = "_mh-1";
export var editor = "_mh-8";
export var editorWrapper = "_mh-7";
export var prefix = "_mh-2";
export var searchIcon = "_mh-3";
export var suffix = "_mh-9";
export var suffixContent = "_mh-a";
export var suffixText = "_mh-b";
export var wrapper = "_mh-0";